import { render, staticRenderFns } from "./GlobalAllergensList.vue?vue&type=template&id=09978626&scoped=true"
import script from "./GlobalAllergensList.vue?vue&type=script&lang=ts"
export * from "./GlobalAllergensList.vue?vue&type=script&lang=ts"
import style0 from "./GlobalAllergensList.vue?vue&type=style&index=0&id=09978626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09978626",
  null
  
)

export default component.exports